import { Link } from 'react-router-dom';
import ModernNavigation from '@/components/ModernNavigation';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Bike, Heart, Leaf, ArrowRight } from 'lucide-react';

const VelosClassiques = () => {
  return (
    <div className="min-h-screen bg-background">
      <ModernNavigation />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-emerald-50 to-white py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
              <Bike className="w-4 h-4 mr-2" />
              Vélos classiques
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Location de vélos classiques
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des vélos confortables et fiables pour découvrir la côte atlantique à votre rythme
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Heart className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Confort optimal</h3>
                <p className="text-sm text-gray-600">Selles ergonomiques et guidons réglables</p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Leaf className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">100% écologique</h3>
                <p className="text-sm text-gray-600">Zéro émission, mobilité douce</p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Bike className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Bien équipés</h3>
                <p className="text-sm text-gray-600">Panier, porte-bagages, antivol inclus</p>
              </CardContent>
            </Card>
          </div>

          {/* Description */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Nos vélos classiques
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Vélos de ville confortables</h3>
                <p className="text-gray-700">
                  Nos vélos classiques sont parfaits pour les balades tranquilles sur les pistes cyclables. Équipés de 6 à 7 vitesses, ils s'adaptent facilement aux différents terrains. Selle confortable, position droite pour une conduite relaxante.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Équipements inclus</h3>
                <p className="text-gray-700">
                  Chaque vélo est équipé d'un panier avant ou d'un porte-bagages arrière, d'un antivol, d'un kit d'éclairage et d'une sonnette. Parfait pour transporter vos affaires de plage ou vos courses.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Entretien régulier</h3>
                <p className="text-gray-700">
                  Tous nos vélos sont entretenus régulièrement et vérifiés avant chaque location. Freins, pneus, chaîne : tout est contrôlé pour votre sécurité et votre confort.
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <Link to="/reserver">
              <Button className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-8 py-3 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all">
                <Bike className="w-5 h-5 mr-2" />
                Réserver un vélo classique
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VelosClassiques;